
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { getTradingRecord, addUserInvoiceInfo, addInvoiceApply } from '@/apis/myInfo/myInfo';
import { Toast } from 'vant';
import { UserInfo } from '@/interfaces/vuexStateInterface';
import StudentHomeApi from '@/apis/ktpStudentHome/index';
import i18n from '@/lang/index'

@Component({})
export default class MyTradeRecord extends Vue {

  private tabActiveName:string = "zhiqian_vipcard";
  private zhiqian_order_lists:any=null;

  value1: number = 0;
  option1: any = [
    { text: '课堂派教学软件年费', value: 0 },
    { text: '课堂派教学软件服务费', value: 1 },
    { text: '软件服务费', value: 2 },
    { text: '服务费', value: 3 }
  ];
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo;
  }
  private draw: boolean = false; // 是否订单可选
  private result: any = [];
  private tradeList: any = [];
  private moment = moment;
  private checked: boolean = false;
  private AllNum = 0;
  private AllPrice = 0;
  private loading: boolean = false;
  private pages: number = 1;
  private Allpages: number = 0;
  private finished: boolean = false;
  private showDetail: boolean = false;
  private detail: any = ''; // 单个数据
  private radio: string = '0';
  private ordernoList: any = [];
  private showOpen: boolean = false;

  private account: string = '';
  private rise: string = '';

  private warning: boolean = false;


  private invoiceno:string = '';
  private bankname:string  = '';
  private bankaccount:string  = '';
  private registeraddress:string  = '';
  private registertel:string = '';
  private invoicetype:string = '0';
  private email:string  = '';
  private telphone:string  = '';
  private deliveryaddress:string  = '';
  private recipients:string  = '';
  private success: boolean = false;

  // 提交申请
  submit() {
    this.ordernoList = [];
    for (let i = 0; i < this.result.length; i++) {
      this.ordernoList.push(this.tradeList[this.result[i]].orderno);
    }
    // this.ordernoList = this.ordernoList.join('|');
    if(this.invoicetype == "0"){
      if(this.email == ""){
        this.$toast('邮箱不能为空');
        return;
      }
      if(this.telphone == ""){
        this.$toast('电话号码不能为空');
        return;
      }
    }else{
      if(this.recipients == ""){
        this.$toast('收件人 不能为空');
        return;
      }
      if(this.deliveryaddress == ""){
        this.$toast('收件人地址 不能为空');
        return;
      }
      if(this.telphone == ""){
        this.$toast('电话号码不能为空');
        return;
      }
    }

    if(this.radio == "0"){
      if(this.invoiceno == ""){
        this.$toast('税号 不能为空');
        return;
      }
      if(this.rise == ""){
        this.$toast('发票抬头 不能为空');
        return;
      }
    }

    const data = {
      title: this.rise,
      type: this.radio,
      invoiceno: this.invoiceno,
      bankname: this.bankname,
      bankaccount: this.bankaccount,
      registeraddress: this.registeraddress,
      registertel: this.registertel,
      invoicetype:this.invoicetype,
      email:this.email,
      telphone:this.telphone,
      recipients:this.recipients,
      deliveryaddress:this.deliveryaddress,
    };
    addUserInvoiceInfo(data)
      .then(() => {
        addInvoiceApply({
          ...data,
          data:data,
          orderno: this.ordernoList
        })
          .then(() => {
            // Toast.success('提交成功')
            this.$setNavInfo({
              type: 'normal',
              title: '交易记录',
              showTitle: true,
              backConfig: () => {
                this.success = false;
                this.showOpen = false;
                this.$setNavInfo({
                  type: 'normal',
                  title: '交易记录',
                  showTitle: true,
                  backConfig: () => {
                    this.$router.push('ktpMy');
                  }
                });
              }
            });
            this.success = true;
          })
          .catch(e => {
            Toast.fail('提交失败');
          });
      })
      .catch(e => {
        Toast.fail('提交失败');
      });
  }
  okDown() {
    this.showOpen = false;
    this.success = false;
    this.$setNavInfo({
      type: 'normal',
      title: '交易记录',
      showTitle: true,
      backConfig: () => {
        this.$router.push('ktpMy');
      }
    });
  }
  next() {
    if (this.result.length === 0) {
      this.$toast('请选择订单');
    } else {
      this.showOpen = true;
      this.$setNavInfo({
        type: 'normal',
        title: '开具发票',
        showTitle: true,
        backConfig: () => {
          this.showOpen = false;
          this.$setNavInfo({
            type: 'normal',
            title: '交易记录',
            showTitle: true,
            backConfig: () => {
              this.$router.push('/ktpMy');
            }
          });
        }
      });
    }
  }
  checkAll(checked: boolean) {
    const checkboxs: any = this.$refs.checkboxGroup;
    if (checkboxs != undefined) {
      if (checked) {
        // 全选
        checkboxs.toggleAll(true);
        this.AllNum = this.tradeList.length;
        const price = 0;
        for (let i = 0; i < this.tradeList.length; i++) {
          this.AllPrice += Number(this.tradeList[i].total_fee);
        }
      } else {
        // 全不选
        this.AllNum = 0;
        this.AllPrice = 0;
        checkboxs.toggleAll(false);
      }
    }
  }
  // 单个选择
  radioChoose(val: any) {
    this.AllNum = this.result.length;
    let Aprice = 0;
    for (let i = 0; i < this.result.length; i++) {
      Aprice += Number(this.tradeList[this.result[i]].total_fee);
    }
    this.AllPrice = Aprice;
  }
  toggleAll() {
    const checkboxs: any = this.$refs.checkboxGroup;
    checkboxs.toggleAll();
  }

  onLoad() {
    if (this.pages < this.Allpages) {
      this.pages++;
      this.checked = false;
      this.getData(this.pages);
      this.loading = false;
    } else {
      this.finished = true;
    }
  }

  detailShow(index: number) {
    this.detail = this.tradeList[index];
    this.showDetail = true;

    if (this.userInfo.usertype === '1') {
      this.$setNavInfo({
        type: 'normal',
        title: '开具发票',
        showTitle: true,
        btnGroup: [],
        backConfig: () => {
          this.showDetail = false;
          this.$setNavInfo({
            type: 'normal',
            title: '交易记录',
            showTitle: true,
            backConfig: () => {
              this.$router.push('/ktpMy');
            },
            btnGroup: [
              {
                text: '开发票',
                type: 'text',
                callback: this.drawABill,
                color: '#4285F4'
              }
            ]
          });
        }
      });
    }else{
      this.$setNavInfo({
        type: 'normal',
        title: '交易记录',
        showTitle: true,
        btnGroup: [],
        backConfig: () => {
          this.showDetail = false;
          this.$setNavInfo({
            type: 'normal',
            title: '交易记录',
            showTitle: true,
            backConfig: () => {
              this.$router.push('/ktpMy');
            }
          });
        }
      });
    }
  }
  // 企业或者个人
  openAcc(name: string) {
    this.account = name;
  }

  // 选择纸质发票
  invioceChage(name: string) {
    this.invoicetype = name;
    if (name === '1') {
      this.warning = true;
    } else {
      this.warning = false;
    }
  }

  //获取之前卡的订单
  getZhiqianVipCardOrderLists(){
    StudentHomeApi.getOrderLists().then((res)=>{
      this.zhiqian_order_lists = res;
    });
  }

  created() {
    if (this.userInfo.usertype === '1') {
      this.$setNavInfo({
        type: 'normal',
        title: '交易记录',
        showTitle: true,
        btnGroup: [
          {
            text: '开发票',
            type: 'text',
            callback: this.drawABill,
            color: '#4285F4'
          }
        ]
      });
    } else {
      this.$setNavInfo({
        type: 'normal',
        title: '交易记录',
        showTitle: true
      });
      //这里获取之前卡的订单处理
      this.getZhiqianVipCardOrderLists();
    }
    this.getData(this.pages);
  }

  drawABill() {
    if (!this.draw && this.tradeList.length === 0) {
      this.$toast('您没有订单可以开发票');
    } else {
      this.draw = !this.draw;
      this.$setNavInfo({
        type: 'normal',
        title: '交易记录',
        showTitle: true,
        btnGroup: [
          {
            text: this.draw ? (i18n.t('Common.取消') as string) : '开发票',
            type: 'text',
            callback: this.drawABill,
            color: '#4285F4'
          }
        ]
      });
    }
  }

  getData(page: number) {
    getTradingRecord({ page }).then((res: any) => {
      for (let i = 0; i < res.data.length; i++) {
        res.data[i].total_fee = res.data[i].total_fee.split('');

        const legth = res.data[i].total_fee.length;
        if (legth === 1) {
          res.data[i].total_fee.splice(-2, 0, '0', '.', '0');
        } else if (legth === 2) {
          res.data[i].total_fee.splice(-2, 0, '0', '.');
        } else {
          res.data[i].total_fee.splice(-2, 0, '.');
        }

        res.data[i].total_fee = res.data[i].total_fee.join('');
      }
      this.tradeList = this.tradeList.concat(res.data);
      this.Allpages = res.pages;
    });
  }
}
